/* ===============================
   GLOBAL COMMUNITY COUNTERS
================================ */

document.addEventListener("DOMContentLoaded", () => {

  const sections = document.querySelectorAll('[id^="community-"]');

  sections.forEach(section => {

    const counters = section.querySelectorAll(".counter");
    if (!counters.length) return;

    let started = false;

    function animateCounter(counter) {
      const target = +counter.dataset.target;
      const speed = 200;

      const update = () => {
        const value = +counter.innerText;
        const increment = Math.ceil(target / speed);

        if (value < target) {
          counter.innerText = value + increment;
          setTimeout(update, 15);
        } else {
          counter.innerText = target;
        }
      };

      update();
    }

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !started) {
          counters.forEach(counter => animateCounter(counter));
          started = true;
        }
      });
    }, { threshold: 0.5 });

    observer.observe(section);

  });

});
